<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import CodeSnippet from "../../../editor/nodes/CodeSnippet.vue";

export default CodeSnippet.extend({
  name: "CodeSnippetV3",
  mixins: [FirebaseNodeV3],
})
</script>
